import React, { useState, useRef, useEffect } from "react";
import { Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import MicIcon from '@mui/icons-material/Mic';
import StopCircleIcon from '@mui/icons-material/StopCircle';

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#fff',
  border: `1px solid ${theme.palette.success.main}`,
  color: theme.palette.success.main,
  '&:hover': {
    backgroundColor: theme.palette.success.light,
    color: '#fff',
  },
  '& .MuiSvgIcon-root': {
    marginLeft: theme.spacing(1),
  },
  padding: theme.spacing(1, 2),
}));

const SpeechToTextButton = ({ onTranscript }) => {
  const [isListening, setIsListening] = useState(false);
  const recognitionRef = useRef(null);

  useEffect(() => {
    if (!('webkitSpeechRecognition' in window)) {
      console.warn("Speech recognition not supported in this browser.");
      return;
    }

    const Recognition = window.webkitSpeechRecognition;
    const recognition = new Recognition();

    recognition.continuous = false;
    recognition.interimResults = false;
    recognition.lang = 'en-US';

    recognition.onresult = (event) => {
      const transcript = event?.results[0][0]?.transcript;
      onTranscript(transcript);
      console.log(transcript);
    };

    recognition.onerror = (event) => {
      console.error("Speech recognition error", event?.error);
      setIsListening(false);
    };

    recognition.onend = () => {
      setIsListening(false);
    };

    recognitionRef.current = recognition;

    return () => {
      recognition.stop();
    };
  }, [onTranscript]);

  const handleSpeechToText = () => {
    if (!recognitionRef.current) return;

    if (isListening) {
      recognitionRef.current.stop();
    } else {
      recognitionRef.current.start();
    }

    setIsListening(!isListening);
  };

  return (
    <Box display="flex" justifyContent="flex-end" width="100%">
      <StyledButton
        onClick={handleSpeechToText}
        endIcon={isListening ? <StopCircleIcon color="error" /> : <MicIcon />}
      >
        <Typography variant="button">
          {isListening ? 'Stop Listening' : 'Start Speaking'}
        </Typography>
      </StyledButton>
    </Box>
  );
};

export default SpeechToTextButton;
